import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    currentSelect: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      value: '',
      visible: false,
      loading: true,
      gridData: [],
      options: [],
      date: [this.$t('559'), this.$t('560'), this.$t('561'), this.$t('562'), this.$t('563'), this.$t('564'), this.$t('565')],
      checkList: []
    };
  },
  methods: {
    remoteMethod: function remoteMethod(query) {
      var _this = this;
      if (query !== '') {
        this.loading = true;
        setTimeout(function () {
          _this.loading = false;
          _this.options = _this.list.filter(function (item) {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    }
  }
};